<template>
	<div style="width: 100vw;">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div v-if="equipment == 'pc'" style="height: 30px;width: 100%;"></div> -->
		<div :style="equipment == 'pc'?{
				// width:equipment == 'pc'?'1280px':'100%'
				...boxStyleOne,
				minHeight:`calc(100vh - ${placeNavHeight}px)`
			}:{
				width:'100%',
				minHeight:`calc(100vh - ${placeNavHeight}px)`
			}" style="display: flex;margin: auto;">
			<div class="tab" v-if="equipment == 'pc'" style="height: 100%;">
				<div
					style="height: 230px;width: 300px;background-color: #fff;display: flex;align-items: center;justify-content: center;flex-direction: column;">
					<img v-if="userInfo.avatar" :src="userInfo.avatar"
						style="width: 96px;height: 96px;border-radius: 100%;border: solid 1px #f5f5f5;" />
					<img v-if="!userInfo.avatar" src="../img/tx.png"
						style="width: 96px;height: 96px;border-radius: 100%;border: solid 1px #f5f5f5;" />
					<div style="margin-top: 10px;font-weight: bold;">{{userInfo.name}}</div>
					<div style="margin-top: 10px;">{{userInfo.email}}</div>
				</div>
				<div style="width: 300px;border-top: solid 1px #f5f5f5;background-color: #fff;">
					<div @click="changeItem(item)" :style="{
						background:tabItem == item.name?'#e9ecef':'none'
					}" style="border-bottom : solid 1px #f5f5f5;" v-for="(item,index) in tabList" :key="index">
						<div style="height: 42px;line-height: 42px;padding-left: 15px;cursor: pointer;font-size: 14px;">
							{{item.title}}
						</div>
					</div>
				</div>
			</div>
			<div :style="{
				marginLeft:equipment == 'pc'?'20px':'0px',
				minHeight:equipment == 'pc'?'500px':'100%'
			 }" style="background-color: #fff;width: 100%;padding: 10px 20px;">
				<div v-if="equipment == 'phone'">
					<el-select @change="chnagePage" size="small" v-model="tabItem">
						<el-option v-for="(item,index) in tabList" :key="index" :label="item.title" :value="item.name">
						</el-option>
					</el-select>
				</div>
				<div style="height: 20px;width: 100%;"></div>
				<div style="display: flex;align-items: center;">
					<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
					<div style="margin-left: 10px;font-weight: bold;">{{selectItem.title}}</div>
				</div>
				<div>
					<!-- 导入的组件 -->
					<component :userInfo="userInfo" :localPageData="localPageData" :equipment="equipment"
						:is="selectItem.name">
					</component>
				</div>
			</div>
		</div>
		<!-- <div v-if="equipment == 'pc'" style="height: 30px;width: 100%;"></div> -->
	</div>
</template>

<script>
	import {
		getaccountEditData,
		getLoginOut
	} from '../../../api/all.js'
	import orders from './account/orders.vue'
	import edit from './account/edit.vue'
	import addresses from './account/addresses.vue'
	import password from './account/password.vue'
	import rmas from './account/rmas.vue'
	import wishlist from './account/wishlist.vue'
	import commissionOrders from './account/commissionOrders.vue'
	import commissionUsers from './account/commissionUsers.vue'
	export default {
		components: {
			orders,
			edit,
			addresses,
			password,
			rmas,
			wishlist,
			commissionOrders,
			commissionUsers
		},
		props: {
			footerHeight: {
				type: Number,
				default: 0
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		watch: {
			$route: {
				immediate: true,
				deep: true,
				handler: async function(to, from) {
					this.tabList.forEach(e => {
						if (to.path.indexOf(e.path) != -1) {
							this.tabItem = e.name
							this.selectItem = e
						}
					})
				}
			}
		},
		data() {
			return {
				loading: false,
				userInfo: {},
				tabItem: 'orders',
				selectItem: {
					path: "/account/orders",
					name: 'orders',
					title: this.$t('h.myOrder')
				},
				tabList: [{
						path: "/account/orders",
						name: 'orders',
						title: this.$t('h.myOrder')
					}, {
						path: "/account/edit",
						name: 'edit',
						title: this.$t('h.changeUserInfo')
					},
					{
						path: "/account/password",
						name: 'password',
						title: this.$t('h.changePassword')
					},
					{
						path: "/account/addresses",
						name: 'addresses',
						title: this.$t('h.myAddress')
					},
					{
						path: "/account/wishlist",
						name: 'wishlist',
						title: this.$t('h.myWishlist')
					},
					{
						path: "/account/rmas",
						name: 'rmas',
						title: this.$t('h.myRmas')
					},
					{
						path: "/commission/shop/orders_index",
						name: 'commissionOrders',
						title: this.$t('h.userCommission')
					},
					{
						path: "/commission/shop/users_index",
						name: 'commissionUsers',
						title: this.$t('h.commissionUsers')
					},
					{
						path: "/account/loginOut",
						name: 'loginOut',
						title: this.$t('h.loginOut')
					}
				]
			}
		},
		async mounted() {

			if (!this.$cookies.get("login")) {
				this.$router.replace({
					path: "/userlogin"
				})
				return 
			}

			try {
				this.loading = true
				const data = await getaccountEditData()
				console.log('data', data)
				this.userInfo = data.data.data
				this.loading = false
			} catch (e) {
				this.loading = false
			}

		},
		methods: {
			chnagePage(e) {
				console.log('e', e)
				let path = ''
				this.tabList.forEach(item => {
					if (item.name == e) {
						path = item.path
					}
				})
				this.$router.push({
					path

				})
			},
			async changeItem(item) {
				if (item.name == 'loginOut') {
					this.loading = true
					const data = await getLoginOut()
					console.log('data', data)
					this.$router.push({
						path: '/userlogin',

					})
					this.loading = false
					return
				}

				this.tabItem = item.name
				this.selectItem = {
					...item
				}
				this.$emit('changeAccount', item.path)
				// this.$router.push({
				// 	path: item.path,
				// })
				this.$forceUpdate()
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #635bff;
	}

	/deep/ .el-select .el-input__inner:focus {
		border: 1px solid #635bff;
	}
</style>